import dashStyles from '../../pages/admin/AdminDashboardPage.module.css';

interface Props {
  active?: boolean;
  payload?: Array<{ name?: string | number; value?: number | string; color?: string; dataKey?: string | number }>;
  label?: string | number;
  /** Cómo escribir el valor de cada serie. */
  formato: (nombre: string, valor: number) => string;
  /** Etiqueta alternativa a la del eje (p. ej. fecha completa). */
  titulo?: (label: string) => string;
}

/** Tooltip de recharts con los estilos del dashboard (sirve en tema claro y oscuro). */
export default function TooltipGrafico({ active, payload, label, formato, titulo }: Props) {
  if (!active || !payload?.length) return null;
  const filas = payload.filter((p) => p.value != null);
  if (!filas.length) return null;
  const etiqueta = label != null ? String(label) : '';
  return (
    <div className={dashStyles.chartTooltip}>
      {etiqueta && <p className={dashStyles.chartTooltipLabel}>{titulo ? titulo(etiqueta) : etiqueta}</p>}
      {filas.map((p) => (
        <p key={String(p.dataKey ?? p.name)} className={dashStyles.chartTooltipRow}>
          <span className={dashStyles.legendDot} style={{ background: p.color }} />
          {String(p.name)}: <strong>{formato(String(p.name), Number(p.value))}</strong>
        </p>
      ))}
    </div>
  );
}
